<template>
  <div>
    <div
        class="wrapper questions-wrapper"
        :class="{'questions-wrapper_mobile': isMobile}"
        id="single-question-page"
        v-if="questionList.length">
      <div class="float-block">
        <div v-show="!isMobile" style="position: fixed;width:inherit;" ref="sideBar" class="float-block-fixed">
          <v-card v-if="!examSubmitted">
            <h4 class="keymap-tips-h">{{ $t('question.KeyboardShortcutsIntroduction') }}</h4>
            <ul class="keymap-tips-content">
              <li>{{ $t('question.IntroductionOne') }}</li>
              <li>{{ $t('question.IntroductionTwo') }}</li>
            </ul>
          </v-card>
          <v-card v-if="examSubmitted" class="answer-result">
            <div>
                <h4>{{ $t('question.AnswerResults') }}</h4>
                 <ul class="keymap-tips-content">
                  <li>{{ $t('question.FullMarks') }}: {{ totalScore }}</li>
                 <li>{{ $t('question.YourScore') }}: {{  myScore }}</li>
                </ul>
            </div>
          </v-card>
          <v-card>
            <question-list
              :activeIndex="singleQuestionIndex"
              :list="questionList"></question-list>
          </v-card>
        </div>
        <div class="report-button-container">
          <report-error
          :key="question?question.question_id: 0"
          v-if="question&&question.question_id"
          :navigation="navigation"
          :index="questionIndex"
          :question-id="question.question_id"></report-error>
        </div>
      </div>
      <single-question
        :questionList="questionList"
        :visibleRightAnswer="examSubmitted"
        :index="singleQuestionIndex"
      ></single-question>
    </div>
    <question-footer
      v-if="questionList.length"
      :examInfo="examInfo"
      :questionList="questionList"
      @finish-skill="$emit('finish-skill')"
      @checked-question="emitBreakPoint"
    ></question-footer>
    <div key="empty-image-container"
      v-show="fetched && questionList.length === 0"
      class="empty-image-container">
      <img src="@/assets/img/comet/issueList/cuokong@2x.png" alt="">
      <h5 v-if="!fetchedFail">no question collection in this chapter.</h5>
      <h5 v-else>Loading failed Please try again later</h5>
    </div>
    <ct-loading ref="loader" global>
      <span class="small-loader" slot="loader">
        <span class="loading"></span>
      </span>
    </ct-loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VCard from '@ca/components/Card'
import SingleQuestion from './Question.vue'
import QuestionList from './QuestionList.vue'
import QuestionFooter from './QuestionFooter.vue'
import ReportError from './ReportError'
// import api from '@ca/api'
import { questionType } from '@ca/constants'
import { globalMixin } from '@ca/mixins'

export default {
  name: 'SubContent',
  components: {
    'single-question': SingleQuestion,
    'report-error': ReportError,
    'v-card': VCard,
    'question-list': QuestionList,
    'question-footer': QuestionFooter
  },
  props: {
    navigation: Array,
    origin: {
      type: Number,
      default: 1050100,
      required: false
    },
    myScore: {
      type: Number,
      default: 0
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    questionList: {
      type: Array,
      default: () => []
    },
    isPublishAnswer: {
      type: Number,
      default: 0
    }
  },
  mixins: [globalMixin],
  data () {
    return {
      enterTimestamp: +new Date(),
      readQuestionTimer: null,
      stayQuestionSenconds: 10000,
      breakPointIndex: this.$route.query.index ? Number(this.$route.query.index) : null,
      //   questionList: [],
      questionType: questionType[this.$route.path.split('/')[1]],
      fetched: false,
      fetchedFail: false,
      examId: this.$route.params.exam_id,
      isMobile: window.innerWidth <= 768
    //   totalScore: 0
    }
  },
  watch: {
    question (value) {
      this.$nextTick(() => {
        this.countStaySeconds(value)
        const ref = this.$refs.sideBar
        if (ref) {
          const top = ref.offsetTop + ref.offsetHeight
          document.querySelector('.report-button-container').style.top = top + 'px'
        }
      })
    }
  },
  computed: {
    ...mapGetters('answer', ['question', 'questionIndex', 'examSubmitted']),
    singleQuestionIndex () {
      if (this.$route.path.split('/')[1] === 'answer' && this.breakPointIndex >= 0 && this.breakPointIndex < this.questionList.length) {
        return this.breakPointIndex
      } else {
        return null
      }
    },
    totalScore () {
      let val = 0

      this.questionList.forEach(item => {
        val += item.mark
      })
      return val
    }
  },
  mounted () {
    // this.getQuestionList()
  },
  destroyed () {
    this.readQuestionTimer = null
    this.hideLoading(this.$refs.loader)
  },
  methods: {
    ...mapActions('answer', ['getList']),
    countStaySeconds (value) {
      this.readQuestionTimer = null
      this.readQuestionTimer = window.setTimeout(() => {
        this.emitBreakPoint({ question_id: value.question_id })
        this.readQuestionTimer = null
      }, this.stayQuestionSenconds)
    },
    emitBreakPoint (data) {
      const parameters = Object.assign({}, {
        chapter: (this.navigation && this.navigation[0]) || '',
        section: (this.navigation && this.navigation[1]) || '',
        sectionId: this.origin,
        questionIndex: this.questionIndex
      }, data)
      this.$emit('set-breakpoint-record', parameters)
    }
    // // 获取题目列表
    // getQuestionList () {
    //   this.fetchedFail = false
    //   this.$refs.loader.open()
    //   api.getExamQuestionList({
    //     params: {
    //       work_id: +this.$route.params.exam_id,
    //       class_id: +this.$route.params.class_id,
    //       subclass_id: +this.$route.params.subclass_id
    //     }
    //   }).then((res) => {
    //     this.hideLoading(this.$refs.loader)
    //     this.fetched = true
    //     this.questionList = [...res.data.data || []]
    //     this.totalScore = 0
    //     this.questionList.forEach(item => {
    //       this.totalScore += item.mark
    //     })
    //   }, () => {
    //     this.fetchedFail = true
    //   })
    // }
  }

}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
@import '@/styles/_loader.scss';
.answer-result {
    padding: 10px;
    h4 {
        text-align: center;
    }
}
.keymap-tips{
  &-h{
    line-height: 1;
    text-align: center;
    font-family:SFProDisplay-Medium;
    font-weight:500;
    padding-top: 32px;
  }
  &-content{
    color:rgba(54,85,114,1);
    padding:16px 16px 8px;
    padding-bottom:24px;
    margin-bottom: 14px;
    font-size: 14px;
    font-family: SFProDisplay;
    font-weight: 400;
    letter-spacing: -0.5px;
    > li {
      line-height:18px;
      margin-bottom: 12px;
    }
  }
}
.questions-wrapper{
    // position: relative;
  color: $secondary;
  min-height: 85vh;
}
.float-block{
  width:316px;
  position:relative;
  float: right;
  z-index: 1;
  &:before,
  &:after {
    content: " ";
    display: table;
  }
}
.report-button-container{
  margin-left: -130px;
  position: fixed;
  top: 60%!important;
//   left: 50%;
  margin-top: -32px;
}
.empty-image-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  img {
    width: 142px;
  }
  h5 {
    margin-top: 30px;
    font-size:14px;
    font-weight:400;
    color:rgba(186,196,206,1);
    line-height:14px;
  }
}
.questions-wrapper_mobile {
    .questions-wrapper {
        position: relative;
    }
    .report-button-container{
        margin-left: -130px;
        position: fixed;
        top: 190px!important;
        right: 0;
        margin-top: -32px;
    }
}
</style>
